// Feature flags removed - all features always enabled (no-op shim).
// ponytail: replaces deleted feature-flags plugin; return true = all features on,
// upgrade to real flags if paywall is reintroduced.
export const FF_AI_PROVIDERS = 'ai-providers'
export const FF_BUTTON_FIELD = 'button-field'

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.provide('featureFlagIsEnabled', () => true)
})
